export const getIsEnabled = (state) => {
    return state.InactivityTimerData.isEnabled;
};
